export default "__VITE_ASSET__a6b76371__"